/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */

// Import custom modules

import 'bootstrap';
import App from './modules/app.js';
import Maps from './modules/maps.js';
import Colcade from 'colcade';
import Swiper from 'swiper/swiper-bundle';
import 'theia-sticky-sidebar';
import Chart from 'chart.js/auto';
import { Tooltip } from 'chart.js';

const app = new App();
const maps = new Maps();

let body = document.body;
let windowWidth = window.innerWidth;
let wh = window.innerHeight;
let vh = wh * 0.01;
let scrollPosition = window.scrollY;
let lastScrollPosition = scrollPosition;
let scrollTimeout;
let resizeTimeout;
let mobileNavigationActive = false;
let carousels = document.querySelectorAll( '.carousel .swiper' );
let offsetCarousels = document.querySelectorAll( '.offset-carousel' );
let threeColumnCarousels = document.querySelectorAll( '.three-column-carousel' );
let autoplayVideos = document.querySelectorAll( 'video[autoplay]' );
let masonryBlocks = document.querySelectorAll('.masonry-block');
let quoteCarousels = document.querySelectorAll('.quote-carousel');
let pricesCollapses = document.querySelectorAll('.price-collapse');
let $processes = $('.process');

/**
 * Youtube
 */

$( '.bd-youtube-modal-xl' ).on( 'hide.bs.modal', function( e ) {
  $( 'iframe' ).attr( 'src', $( 'iframe' ).attr( 'src' ) );
});

/**
 * Jump to main nagivation
 */

/* $( '.jump-to-main' ).on( 'click', function( e ) {
  e.preventDefault();
  $( 'html, body' ).animate({
    scrollTop: ( $( '.hero-container' ).offset().top + $( '.hero-container' ).height() ) - $( '#site-header' ).outerHeight()
  }, 400 );
}); */

/**
 * Hack for select placeholder color
 */

$( 'select' ).on( 'change', function() {
  if ( $( this ).val() ) {
    if ( $( this ).parents( '.cta' ) ) {
      return $( this ).css( 'color', '#fff' );
    } else {
      return $( this ).css( 'color', '#212121' );
    }
  } else {
    if ( $( this ).parents( '.cta' ) ) {
      return $( this ).css( 'color', 'rgba(255, 255, 255, .75)' );
    } else {
      return $( this ).css( 'color', 'rgba(33, 33, 33, .5)' );
    }
  }
});

/**
 * Carousel
 */
if ( carousels.length ) {

  carousels.forEach( ( element ) => {
    var swiperSlides = element.querySelectorAll('.swiper-slide');
    var swiperLoop = false;

    if ( swiperSlides.length > 3 || windowWidth < 1400 ) {
      swiperLoop = true;
    }

    var swiper = new Swiper( element, {
      slidesPerView: 'auto',
      grabCursor: true,
      loop: swiperLoop,
      centeredSlides: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  });
}

/**
 * Offset carousel
 */

if ( offsetCarousels.length ) {

  offsetCarousels.forEach((element) => {

    var swiper = new Swiper(element, {
      slidesPerView: 1,
      enabled: false,
      grabCursor: true,
      breakpoints: {
        0: {

          enabled: false,
        },
        1005: {
          slidesPerView: 'auto',
          enabled: true,
        }
      },
      navigation: {
        nextEl: element.parentNode.parentNode.parentNode.querySelector('.swiper-button-next'),
        prevEl: element.parentNode.parentNode.parentNode.querySelector('.swiper-button-prev'),
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
    });

    swiper.on('slideChange', function () {
      var swiperContainer = this.el;

      if (swiper.isBeginning) {
        swiperContainer.classList.remove('reached-end');
        swiperContainer.classList.add('reached-begining');
      } else if (swiper.isEnd) {
        swiperContainer.classList.remove('reached-begining');
        swiperContainer.classList.add('reached-end');
      } else {
        swiperContainer.classList.remove('reached-begining');
        swiperContainer.classList.remove('reached-end');
      }
    });

    swiper.on('beforeResize', function () {

      if (windowWidth > 764) {
        swiper.slideTo(0, 0);
      }
    });
  });
}

/**
 * Three column carousel
 */
if ( threeColumnCarousels.length ) {

  threeColumnCarousels.forEach( ( element ) => {

    var swiper = new Swiper( element, {
      slidesPerView: 'auto',
      grabCursor: true,
      breakpoints: {
        1005: {
          slidesPerView: 1,
          enabled: false,
        }
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });

    swiper.on( 'beforeResize', function () {

      if ( windowWidth > 764 ) {
        swiper.slideTo(0, 0);
      }
    });
  });
}

/**
 * Quotes carousel
 */
 if ( quoteCarousels.length ) {

  quoteCarousels.forEach((element) => {

    var swiper = new Swiper(element, {
      slidesPerView: 'auto',
      grabCursor: true,
      centeredSlides: true,
      navigation: {
        nextEl: element.querySelector('.swiper-button-next'),
        prevEl: element.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  });
}

/**
 * Colcade (Masonry)
 */
if ( masonryBlocks.length ) {

  for (var i = 0; i < masonryBlocks.length; i++) {
    var $grid = $(masonryBlocks[i]).find('.masonry');

    $grid.colcade({
      columns: '.masonry-col',
      items: '.masonry-item',
    });
  };
}

/**
 * Video auto play
 */
if ( autoplayVideos.length ) {

  autoplayVideos.forEach( ( videoElem ) => {
    let startPlayPromise = videoElem.play();

    if ( ! videoElem.hasAttribute( 'playsinline' ) ) {
      videoElem.setAttribute( 'playsinline', true );
    }

    if (startPlayPromise === undefined) {
      videoElem.setAttribute( 'controls', true );
    }
  });
}

/**
 * Prices block
 */
if ( pricesCollapses.length ) {
  $('[data-toggle="popover"]').popover({
    html: true
  });

  pricesCollapses.forEach( ( element ) => {
    var $collapseElement = $(element);
    var $actionElement   = $collapseElement.parent().find('.price-group-usp-action');

    $collapseElement.on('show.bs.collapse', function () {
      $actionElement.text($actionElement.data('action-hide'));
    });

    $collapseElement.on('hide.bs.collapse', function () {
      $actionElement.text($actionElement.data('action-show'));
    });

  });

  $('[data-target="#collapse-desktop"').on('click', function () {
    var $this          = $(this);
    var $actionElement = $this.find('.price-group-usp-action');

    if ($this.attr('aria-expanded') == 'false') {
      $actionElement.text($actionElement.data('action-hide'));
    } else {
      $actionElement.text($actionElement.data('action-show'));
    }

  });
}

$( '.language-switcher' ).on( 'click', 'button', function( e ) {
  e.preventDefault();

  var $this = $( this );
  var $parent = $this.parent();

  $this.attr( 'aria-expanded', function( index, attr ) {
    return attr == 'false' ? 'true' : 'false';
  });

  $parent.find( '.dropdown-menu' ).toggleClass( 'show' );
});
$(document).ready(function() {
    // Open the dropdown when its toggle button is focused
    $('.language-switcher button').on('focus', function() {
        $(this).parent().find('.dropdown-menu').addClass('show');
        $(this).attr('aria-expanded', 'true');
    });

    // Listen for any focus change within the document
    $(document).on('focusin', function(e) {
        // Check if the new focus is outside the language-switcher
        if (!$(e.target).closest('.language-switcher').length) {
            // If outside, close any open dropdowns
            closeDropdown();
        }
    });
});

function closeDropdown() {
    $('.language-switcher .dropdown-menu').removeClass('show');
    $('.language-switcher button').attr('aria-expanded', 'false');
}
/**
 * ROAS calculator block
 */

if ( $('.roas-calculator').length ) {
  var $block             = $('.roas-calculator');
  var $card              = $block.find('.card');
  var $adSpendEl         = $('#ad-spend');
  var $adRevenueTargetEl = $('#ad-revenue-target');
  var $adRevenueEl       = $('#ad-revenue');
  var $roasEl            = $('#roas');
  var $profitMarginEl    = $('#profit-margin');
  var $roasTargetEl      = $('#roas-target');
  var $roiEl             = $('#roi');
  var adSpendVal         = $adSpendEl.val();
  var adRevenueTargetVal = $adRevenueTargetEl.val();
  var adRevenueVal       = $adRevenueEl.val();
  var roasVal            = $roasEl.val();
  var profitMarginVal    = $profitMarginEl.val();
  var roasTargetVal      = $roasTargetEl.val();
  var roiVal             = $roiEl.val();
  var ctx                = document.getElementById('roas-chart');
  var $roasMessage       = $('.roas-message');
  var $roasTargetMessage = $('.roas-target-message');

  Chart.defaults.font.size = 16;
  Chart.defaults.font.family = "'EuclidCircularA-Regular', 'Helvetica', 'Arial', 'sans-serif'";

  Tooltip.positioners.cursor = function(elements, eventPosition) {
    return eventPosition;
  };

  $block.find('.nav-link').on('click', function() {
    var $activeNavLink = $block.find('.nav-link.active');

    $activeNavLink.attr('aria-selected', 'false');
    $activeNavLink.removeClass('active btn-primary').addClass('btn-outline-primary');

    $block.find('.revenue-options').text($(this).text());
  });

  var roasChart = new Chart(ctx, {
    type: 'bar',
    data: {
      //labels: ['Annonsutgifter', 'Mål för annonsintäkter', 'Annonsintäkter'],
      datasets: [{
        label: '',
        data: [
          {
            x: 'Annonsutgifter',
            y: adSpendVal
          },
          {
            x: 'Mål för annonsintäkter',
            y: adRevenueTargetVal
          },
          {
            x: 'Annonsintäkter',
            y: adRevenueVal
          }
        ],
        backgroundColor: [
          'rgba(0, 191, 165, 1)'
        ],
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: 0
      },
      scales: {
        x: {
          grid: {
            display: false
          }
        },
        y: {
          beginAtZero: true,
          grid: {
            drawOnChartArea: false
          }
        }
      },
      plugins: {
        tooltip: {
          cornerRadius: 4,
          position: 'cursor',
          caretSize: 0,
          padding: 16,
          titleFont: {
            family: "'EuclidCircularA-Semibold', 'Helvetica', 'Arial', 'sans-serif'",
          },
          bodyFont: {
            family: "'EuclidCircularA-Semibold', 'Helvetica', 'Arial', 'sans-serif'",
            size: 32,
          },
          displayColors: false,
          callbacks: {
            label: function(context) {
              let label = context.dataset.label || '';

              if (label) {
                  label += ': ';
              }

              if (context.parsed.y !== null) {

                label += new Intl.NumberFormat('sv-SE', {
                  style: 'currency',
                  currency: 'SEK',
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2,
                }).format(context.parsed.y);
              }

              return label;
            }
          }
        },
        legend: {
          display: false
        }
      }
    }
  });

  $('input[type="number"]').on('keyup mouseup', function() {
    var $this   = $(this);
    var thisId  = $this.attr('id')
    var thisVal = $this.val();

    if (thisId == 'ad-spend' || thisId == 'ad-revenue') {

      if (thisId == 'ad-spend') { // Ad Spend
        adSpendVal         = thisVal;
        adRevenueTargetVal = adSpendVal * 8;
        roasTargetVal      = adRevenueTargetVal * 10;
        roiVal             = profitMarginVal - adSpendVal;
      } else if (thisId == 'ad-revenue') { // Ad Revenue
        adRevenueVal = thisVal;
      }

      roasVal = (adRevenueVal / adSpendVal) * 100;
    } else if (thisId == 'roas') { // ROAS
      roasVal      = thisVal;
      adSpendVal = (adRevenueVal / roasVal) * 100
      roiVal       = profitMarginVal - adSpendVal;
    } else if (thisId == 'profit-margin') { // Profit Margin
      profitMarginVal = thisVal;
      roiVal = profitMarginVal - adSpendVal;
      roasVal = (adRevenueVal / adSpendVal) * 100;
    } else if (thisId == 'roi') { // ROI
      roiVal          = thisVal;
      profitMarginVal = parseInt(roiVal) + parseInt(adSpendVal);
    } else if (thisId == 'ad-revenue-target') {
      adRevenueTargetVal = thisVal;
      adSpendVal         = adRevenueTargetVal * 0.125;
      roasTargetVal      = adRevenueTargetVal * 10;
    } else if (thisId == 'roas-target') { // ROAS Target
      roasTargetVal      = thisVal;
      adSpendVal         = adRevenueTargetVal * 1.25;
      adRevenueTargetVal = roasTargetVal / 10;
    }

    roasChart.data.datasets[0].data[0]['y'] = Math.round(adSpendVal);
    roasChart.data.datasets[0].data[1]['y'] = Math.round(adRevenueTargetVal);
    roasChart.data.datasets[0].data[2]['y'] = Math.round(adRevenueVal);

    $adSpendEl.val(Math.round(adSpendVal*100)/100);
    $adRevenueEl.val(Math.round(adRevenueVal*100)/100);
    $adRevenueTargetEl.val(Math.round(adRevenueTargetVal*100)/100);
    $roasEl.val(Math.round(roasVal*100)/100);
    $profitMarginEl.val(Math.round(profitMarginVal*100)/100);
    $adRevenueTargetEl.val(Math.round(adRevenueTargetVal*100)/100);
    $roiEl.val(Math.round(roiVal*100)/100);
    $roasTargetEl.val(Math.round(roasTargetVal*100)/100);

    $roasMessage.children().addClass('d-none');
    $roasMessage.find('.roas-value').text(roasVal);
    $roasTargetMessage.find('.revenue-target-value').text(adRevenueTargetVal);

    if (roasVal >= 800) {
      $roasMessage.find('.bg-primary-lightest').removeClass('d-none');
    } else if (roasVal < 800 && roasVal >= 400) {
      $roasMessage.find('.bg-warning-lightest').removeClass('d-none');
    } else {
      $roasMessage.find('.bg-danger-lightest').removeClass('d-none');
    }

    roasChart.update();
  });

  $block.find('.revenue-mode').on('click', function() {
    var $this = $(this);

    if ($this.hasClass('collapsed')) {
      $this.text($this.attr('data-label-closed'));
    } else {
      $this.text($this.attr('data-label-expanded'));
    }

    setTimeout(function() {
      var cardHeight = Math.round($('.calculator-card').height());
      roasChart.canvas.parentNode.style.height = cardHeight.toString() + "px";
    }, 400);

  });
}

/**
 * CTA collapse
 */
var ajaxLoaded = false;

$( '.cta' ).find( '[data-parent]' ).on( 'shown.bs.collapse', function() {
  var $this = $(this);
  var $thisId = $this.attr( 'id' );

  if ( ajaxLoaded == false && $('a[href="#' + $thisId + '"][data-dynamic-url]').length ) {

    $.ajax({
      url: $( '[data-dynamic-url]' ).attr( 'data-dynamic-url' ),
      dataType: 'html',
      success: function( data ) {
        ajaxLoaded = true;
        $( '#' + $thisId ).append( data );
      },
      error: function(e) {
          console.log( e );
      }
    });
  }

  $( 'html, body' ).animate({
    scrollTop: $( '#' + $( this ).attr( 'id' ) ).parents( '.text-fields' ).offset().top - $( '#site-header' ).outerHeight()
  }, 500 );
});

/**
 * Load event
 */
window.addEventListener( 'load', (event) => {
  scrollPosition = window.scrollY;

  /**
   * Mobile Navigation
   */

  if ( windowWidth < 1005 ) {
    document.documentElement.style.setProperty( '--vh', `${vh}px` );
  }

  if ( scrollPosition > wh ) {
    body.classList.add( 'past-the-fold' );
  }

  if ( $processes.length ) {

    $processes.each(function() {
      $(this).find('.sticky').theiaStickySidebar();
    });

  }

  document.querySelector( '.main-navigation-toggle' ).addEventListener( 'click', ( e ) => {
    e.preventDefault();

    body.classList.toggle( 'main-navigation-show' );

    if ( body.className.includes( 'main-navigation-show' ) ) {
      mobileNavigationActive = true;
    } else {
      mobileNavigationActive = false;
    }
  });

  /**
   * Scroll event
   */

  window.addEventListener( 'scroll', () => {

    if ( scrollTimeout ) {
      window.cancelAnimationFrame( scrollTimeout );
    }

    scrollTimeout = window.requestAnimationFrame( function() {
      scrollPosition = window.scrollY;

      body.classList.add( 'scrolling' );

      if ( scrollPosition > 0 ) {

        if ( scrollPosition > lastScrollPosition ) {
          body.classList.remove( 'scrolling-up' );
          body.classList.add( 'scrolling-down' );
        } else {
          body.classList.remove( 'scrolling-down' );
          body.classList.add( 'scrolling-up' );
        }

      } else {
        body.classList.remove( 'scrolling' );
        body.classList.remove( 'scrolling-down' );
        body.classList.remove( 'scrolling-up' );
      }

      if ( scrollPosition > wh ) {
        body.classList.add( 'past-the-fold' );
      } else {
        body.classList.remove( 'past-the-fold' );
      }

      lastScrollPosition = scrollPosition <= 0 ? 0 : scrollPosition;
    });
  });



  var ajaxLock = false;
  let teaseBoxes = jQuery('.tease-box');



  jQuery( 'a.load-more' ).click( function( e ) {
      var nonce = jQuery( '.posts' ).data( 'nonce' );
      var postType = jQuery( '.content-filter .active .filter-posts' ).data( 'type' );
      var taxonomy = jQuery( '.content-filter .active .filter-posts' ).data( 'taxonomy' );
      var term = jQuery( '.content-filter .active .filter-posts' ).data( 'term' );
      var totalPosts = parseInt( jQuery( '.posts' ).data( 'total-results' ) );
      var perpage = jQuery( '.posts' ).data( 'perpage' );
      e.preventDefault();
      jQuery( this ).blur(); // Prevent Chrome from keeping button in viewport
      ajaxNextResults( nonce, postType, taxonomy, term, totalPosts, perpage );
  });
  console.log('window on load');
  jQuery( '.case-studies' ).each( function(index) {
      var jQueryThis = jQuery(this);
      var jQueryThisPosts = jQueryThis.find( '.posts' );

      console.log('case-studies each');
      console.log(jQueryThisPosts.data( 'orderby' ));
      if ( jQueryThisPosts.data( 'orderby' ) == 'rand' ) {
          var nonce = jQueryThisPosts.data( 'nonce' );
          var postType = jQueryThisPosts.data( 'post-type' );
          var perpage = jQueryThisPosts.data( 'perpage' );
          var orderby = jQueryThisPosts.data( 'orderby' );
          var postIds = jQueryThisPosts.data( 'post-ids' );

          ajaxDynamicPosts( nonce, postType, perpage, orderby, postIds );
      }
  } );

  if (teaseBoxes.length) {
      teaseBoxes.each(function() {
          var teaseBoxActive    = null;
          var teaseBoxToggleSrc = 'box';
          var teaseBox          = jQuery(this);

          teaseBox.on('click', '.tease-box-toggle', function() {

              if (teaseBoxActive == true) {
                  teaseBoxActive = false;

                  teaseBox.removeClass('active');
                  teaseBox.find('.tease-box-active').removeClass('tease-box-active').addClass('tease-box-sr-only');
              } else {
                  teaseBoxActive = true;

                  teaseBox.addClass('active');
                  teaseBox.find('.tease-box-sr-only').removeClass('tease-box-sr-only').addClass('tease-box-active');
              }

              teaseBoxToggleSrc = 'toggle';
          });

          teaseBox.on('focus', 'input', function() {

              if (teaseBoxActive == false || teaseBoxActive == null && teaseBoxToggleSrc != 'toggle') {
              teaseBoxActive = true;

              teaseBox.addClass('active');
              teaseBox.find('.tease-box-sr-only').removeClass('tease-box-sr-only').addClass('tease-box-active');
              }

              teaseBoxToggleSrc = 'box';
          });

          teaseBox.find('input[type=\"submit\"]').on('click', function() {
              teaseBoxActive    = false;
              teaseBoxToggleSrc = 'box';
          });

          jQuery(document).on('gform_post_render', function(event, form_id, current_page) {

              if (teaseBoxActive != null) {
                  teaseBoxActive = true;

                  teaseBox.addClass('active');
                  teaseBox.find('.tease-box-sr-only').removeClass('tease-box-sr-only').addClass('tease-box-active');
              }
          });

      });
  }

  function ajaxNextResults( nonce, postType, taxonomy, term, totalPosts, perpage ) {
  var postOffset;
  ajaxLock = true;

  postOffset = jQuery( '.posts' ).children().length;

  jQuery.ajax({
  method: 'POST',
  url: '/wp-admin/admin-ajax.php',
  data: {
  action: 'load_more_posts',
  nonce: nonce,
  taxonomy: taxonomy,
  term: term,
  perpage: perpage,
  offset: postOffset,
  totalPosts: totalPosts,
  postType: postType
  }
  }).done( function( data ) {
  var json, postOffset, target, totalPosts, percentage;
  json = jQuery.parseJSON( data );
  target = '.posts';

  jQuery( json.content ).addClass( 'appending' ).appendTo( target ).delay( 50 ).queue( function() {
  jQuery( this ).addClass( 'appended' );
  });

  postOffset = jQuery( '.posts' ).children().length;

  ajaxLock = false;
  totalPosts = parseInt( jQuery( '.posts' ).data( 'total-results' ) );

  if ( postOffset > totalPosts ) {
  postOffset = totalPosts;
  }

  percentage = ( postOffset / totalPosts ) * 100;

  if ( 100 < percentage ) {
  percentage = 100;
  }

  if ( 100 == percentage ) {
  jQuery( 'a.load-more' ).attr( 'style', 'display: none !important;' );
  } else {
  jQuery( 'a.load-more' ).removeAttr( 'style' );
  }

  }).fail( function( jqXHR, textStatus, errorThrown ) {
  ajaxLock = false;
  });
  }

  function ajaxDynamicPosts( nonce, postType, perpage, orderby, postIds ) {
      ajaxLock = true;

      jQuery.ajax({
          method: 'POST',
          url: '/wp-admin/admin-ajax.php',
          data: {
              action: 'load_dynamic_posts',
  nonce: nonce,
  perpage: perpage,
  postType: postType,
              orderby: orderby,
              postIds: postIds
          }
      }).done( function( data ) {
          var json, target;
          json = jQuery.parseJSON( data );
          target = '.posts';
          ajaxLock = false;

          jQuery( target ).html( json.content );
      }).fail( function( jqXHR, textStatus, errorThrown ) {
          ajaxLock = false;
      });
  }
});

/**
 * Resize event
 */
window.addEventListener( 'resize', () => {

  if ( resizeTimeout ) {
    window.cancelAnimationFrame( resizeTimeout );
  }

  resizeTimeout = window.requestAnimationFrame( function() {
    windowWidth = window.innerWidth;
    wh = window.innerHeight;
    vh = wh * 0.01;

    if ( windowWidth < 1005 ) {
      document.documentElement.style.setProperty( '--vh', `${vh}px` );
      $( '.language-switcher').removeClass( 'dropdown' ).addClass( 'dropup' );
    } else {
      document.documentElement.style.removeProperty( '--vh' );
      $( '.language-switcher').removeClass( 'dropup' ).addClass( 'dropdown' );
      $( '[data-toggle="popover"]' ).popover( 'hide' );
    }

    if ( mobileNavigationActive == true ) {

      if ( windowWidth < 1005 ) {
        document.body.classList.add( 'main-navigation-show' );
      } else {
        document.body.classList.remove( 'main-navigation-show' );
      }
    }
  });
});
